import { XML_ConvertDPI } from "./XML_ConvertDPI";
import { XML_GetDX } from "./XML_GetDX";
import { XML_GetScale } from "./XML_GetScale";
import { XML_GetDY } from "./XML_GetDY";

export function XML_ShiftRect(r, drawElement, layer) {
  r.Scale(XML_ConvertDPI(1));
  var scale = XML_GetScale(drawElement, layer); // drawElement["scale"];
  if (scale != null) r.Scale(scale);

  var dx = XML_GetDX(drawElement, layer); // drawElement["dx"];
  var dy = XML_GetDY(drawElement, layer); //  drawElement["dy"];

  if (dx != null && dy != null) r.Shift(dx, dy);
}
